import type { UnknownEvent } from '@faststore/sdk'
import { sendAnalyticsEvent } from '@faststore/sdk'
import { Carousel as CarouselBan } from '@faststore/ui'
import { ImageWithArtDirection } from 'src/components/ui/Image'
import Link from 'src/components/ui/Link'
import imagesConf from 'src/images/config'

import type { CarouselProps, DeviceSource, Item } from './carouselProps'

import './Carousel.scss'

function Carousel({ allItems, marginTop, marginBottom }: CarouselProps) {
  const dynamicImages = allItems?.map((item: Item, index: number) => {
    const deviceSource: DeviceSource = {
      desktop: { media: '', srcSet: '' },
      mobile: { media: '', srcSet: '' },
    }

    item?.sources?.forEach((e) => {
      if (e.media === '(min-width: 40em)') {
        deviceSource.desktop = e
      } else {
        deviceSource.mobile = e
      }
    })

    const desktop = {
      baseUrl: deviceSource?.desktop.srcSet,
      ...imagesConf['carousel.desktop'],
    }

    const mobile = {
      baseUrl: deviceSource.mobile.srcSet,
      ...imagesConf['carousel.mobile'],
    }

    const useOnClick = () => {
      sendAnalyticsEvent<UnknownEvent>({
        name: 'select_promotion',
        params: {
          promo: item.href,
        },
      })
    }

    return (
      <div className="carousel-banner__conten" key={index}>
        <Link as="a" href={item.href} onClick={useOnClick}>
          <ImageWithArtDirection
            desktop={desktop}
            mobile={mobile}
            alt={item.alt}
            objectFit="cover"
            loading="eager"
            className="carousel-banner-image__container"
          />
        </Link>
      </div>
    )
  })

  return (
    <section
      id={allItems.length === 1 ? 'carousel-no-arrows' : 'carousel'}
      style={{ marginTop: `${marginTop}`, marginBottom: `${marginBottom}` }}
    >
      <CarouselBan
        id="bullets-carousel-banner"
        infiniteMode={allItems.length !== 1}
        controls={allItems.length === 1 ? 'navigationArrows' : 'complete'}
        transition={{
          duration: 400,
          property: 'transform',
        }}
      >
        {dynamicImages}
      </CarouselBan>
    </section>
  )
}

export default Carousel
